import { useForm } from 'react-hook-form';
import { useRef, useEffect, useMemo } from 'react';

import { ResumeForm } from '../../../components/common/resume/resume.type';
import { AssistanceFormStep1, AssistanceFormStep2, AssistanceFormStep3, AssistanceFormStep4 } from './assistance-types';

export const useAssistanceData = () => {
  const shouldUpdateRef = useRef(false);

  const getDefaultValues = useMemo(() => {
    return {
      form1: {
        delayed: null,
        date: '',
        time: '',
        selectedVehicle: {},
        vehicles: [],
        plate: '',
        name: '',
        surname: '',
        identifier: '',
        policyCode: '',
      },
      form2: {
        allowGeo: '',
      },
      form3: {
        latitude: 0,
        longitude: 0,
        undergroundParking: undefined,
        externalRoad: undefined,
        locationInformation: '',
        search: '',
        locationDescription: '',
      },
      form4: {
        faultType: undefined,
        notStartingReason: undefined,
        tyreChange: undefined,
        affectedTyres: 0,
        faultInformation: '',
        otherFaultInformation: '',
        redBatteryLight: undefined,
        adults: 0,
        minors: 0,
        passengersWithSpecialNeeds: undefined,
        specialNeedsInformation: '',
        outOfHighway: undefined,
        blockedTyres: false,
      },
      form5: {
        privPolicy: false,
        cookiesPolicy: false,
      },
    };
  }, []);

  // Init of forms
  const form1 = useForm<AssistanceFormStep1>({
    defaultValues: getDefaultValues.form1,
    shouldUnregister: false,
    reValidateMode: 'onChange',
    mode: 'onChange',
    shouldFocusError: true,
  });

  const form2 = useForm<AssistanceFormStep2>({
    defaultValues: getDefaultValues.form2,
    shouldUnregister: false,
    reValidateMode: 'onChange',
    mode: 'onChange',
    shouldFocusError: true,
  });

  const form3 = useForm<AssistanceFormStep3>({
    defaultValues: getDefaultValues.form3,
    shouldUnregister: false,
    reValidateMode: 'onChange',
    mode: 'onChange',
    shouldFocusError: true,
  });

  const form4 = useForm<AssistanceFormStep4>({
    defaultValues: getDefaultValues.form4,
    shouldUnregister: false,
    reValidateMode: 'onChange',
    mode: 'onChange',
    shouldFocusError: true,
  });

  const form5 = useForm<ResumeForm>({
    defaultValues: getDefaultValues.form5,
    shouldUnregister: false,
    reValidateMode: 'onChange',
    mode: 'onChange',
    shouldFocusError: true,
  });

  useEffect(() => {
    if (!shouldUpdateRef.current) {
      form1.reset({
        ...form1.getValues(),
        vehicles: [],
      });
      shouldUpdateRef.current = true;
    }
  }, [form1, getDefaultValues]);

  return { getDefaultValues, form1, form2, form3, form4, form5 };
};
